import React from 'react'

export default function ErrorDisplay(props) {
  return <>Unable to Load Graph.</>
}
